export default Object.freeze({
  AccountToCreate: '09',
  AccountToUpdate: '06',
  AccountToPay: '02',
});
